<template>
  <div class="divider" :style="{'borderLeftColor': bordercolor}">
    <span class="progressBg" :style="dividerStyle"></span>
    <div
      class="awardicon"
      v-if="progress === 1"
      :style="{ 'background-image': 'url(' + trophy + ')' }"
    ></div>
  </div>
</template>

<script>
import iconAwardMedal from 'images/awards-icons/medal.png';
import iconAwardCup from 'images/awards-icons/cup.png';
import iconAwardRibbon from 'images/awards-icons/ribbon.png';
import iconAwardStar from 'images/awards-icons/star.png';
import iconAwardShield from 'images/awards-icons/shield.png';
import iconAwardPlaque from 'images/awards-icons/plaque.png';

export default {
  props: {
    bordercolor: {
      type: String,
      required: true
    },
    awardname: {
      type: String,
      required: true
    },
    progress: {
      type: Number,
      required: true
    },
    progressBg: {
      type: String,
      required: true,
      default: ''
    }
  },

  computed: {
    trophy() {
      switch (this.awardname) {
        case 'medal':
          return iconAwardMedal;
        case 'cup':
          return iconAwardCup;
        case 'ribbon':
          return iconAwardRibbon;
        case 'star':
          return iconAwardStar;
        case 'plaque':
          return iconAwardPlaque;
        case 'shield':
          return iconAwardShield;
        default:
          return '';
      }
    },

    dividerStyle() {
      return {
        background: `url(${this.progressBg})`,
        width: `${this.progress * 100}%`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.divider {
  display: flex;
}
</style>
